import { render, staticRenderFns } from "./RptMchTraDet.vue?vue&type=template&id=4b4b0328"
import script from "./RptMchTraDet.vue?vue&type=script&lang=js"
export * from "./RptMchTraDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports